<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement" style="padding-top:100px">
<p>My second worst nightmare is that I have to sit my higher mathematics again, and I know nothing.</p>
<p>And I mean nothing.</p>
<p>Nothing.</p>
<p>Have got used to that word throughout life and its variation: nothingness.</p>
<p>My own personal nightmare follows on from that.</p>
<p>It all stems from not being.</p>
<p>And not nothingness.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?818561ea